import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../../../../utils/TestIds';
import { StatusBadge } from '../../../../StatusBadge';
export function BadgeCell(param) {
    let { value, skin, info, testId } = param;
    const testIds = getTestIds(testId);
    if (value === '') return null;
    return /*#__PURE__*/ _jsx(StatusBadge, {
        skin: skin,
        info: info,
        testId: testIds.badge(),
        children: value
    });
}
